import axios from 'axios';

//request times out after 30 seconds
axios.defaults.timeout = 1000 * 30;

const useAxios = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
});

export const publicAxios = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
});


useAxios.interceptors.request.use((config) => {
  const progressBar = document.getElementById('progress-bar');
 const session = JSON.parse(localStorage.getItem("sbaj_session") as string);

//   progressBar?.classList.add('visible');
  progressBar?.classList.add('invisible');
  config.headers!['Authorization'] = `Bearer ${session?.token}`;

  return config;
});

publicAxios.interceptors.request.use((config) => {
  const progressBar = document.getElementById('progress-bar');

//   progressBar?.classList.add('visible');
  progressBar?.classList.add('invisible');

  return config;
});


export default useAxios;
